import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface User {
  id: number;
  username: string;
}

export interface LoggedInUser {
  loggedInUser?: User;
}

// Define the initial state using that type
const initialState: LoggedInUser = {};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setLoggedInUser: (state, action: PayloadAction<User>) => {
      const payload = action.payload;
      state.loggedInUser = payload;
    },
    logoutUser: (state) => {
      state.loggedInUser = undefined;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setLoggedInUser, logoutUser } = userSlice.actions;

export default userSlice.reducer;
